import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

// -------

import axios from 'app/services/http/axios';
import {Actions} from './slice';
import { objectToUrl, routePath } from 'app/services/helpers'

import { Api } from 'modules/Admin/Inventory'

// -------

function* getList({payload: {pageNumber, filters}}) {

  try {
    let route = Api.types;
    route += objectToUrl({
      ...filters,
      page: pageNumber
    }, true)

    const response = yield call(axios.get, route);
    yield put(Actions.getListSuccess(response));

  } catch (e) {
    return yield put(Actions.getListFailed(e));
  }
}

function* getStatistics() {
  try {
    let route = Api.typesStatistics;
    const response = yield call(axios.get, route);
    yield put(Actions.getStatisticsSuccess(response));

  } catch (e) {
    return yield put(Actions.getStatisticsFailed(e));
  }
}

// ------- ACTIONS

function* toDelete({payload: {id}}) {
  try {
    let route = routePath(Api.type, { id });
    const response = yield call(axios.delete, route);
    yield put(Actions.toDeleteSuccess(response));
    toast.success('Type deleted successfully');
  } catch (e) {
    return yield put(Actions.toDeleteFailed(e));
  }
}

function* toggleStatus({payload: {id}}) {
  try {
    let route = routePath(Api.typeToggleStatus, { id });
    const response = yield call(axios.post, route);
    yield put(Actions.toggleStatusSuccess(response));
    toast.success('Type status updated successfully');
  } catch (e) {
    return yield put(Actions.toggleStatusFailed(e));
  }
}

function* bulkDelete({payload: {ids}}) {
  try {
    let route = Api.typesBulkDelete;
    const response = yield call(axios.post, route, { ids });
    yield put(Actions.bulkDeleteSuccess(response));
    toast.success(`${ids.length} types deleted successfully`);
  } catch (e) {
    return yield put(Actions.bulkDeleteFailed(e));
  }
}

function* exportData() {
  try {
    let route = Api.typesExport;
    const response = yield call(axios.get, route, {
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `types-${new Date().toISOString().split('T')[0]}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    yield put(Actions.exportDataSuccess());
    toast.success('Types exported successfully');
  } catch (e) {
    return yield put(Actions.exportDataFailed(e));
  }
}

// -------

export function* watchInventoryTypesListSaga() {
  yield takeLatest(Actions.getList.type, getList)
  yield takeLatest(Actions.getStatistics.type, getStatistics)
  yield takeLatest(Actions.toDelete.type, toDelete)
  yield takeLatest(Actions.toggleStatus.type, toggleStatus)
  yield takeLatest(Actions.bulkDelete.type, bulkDelete)
  yield takeLatest(Actions.exportData.type, exportData)
}

export default watchInventoryTypesListSaga
